/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class CalendarWeekTask {
  public days: boolean[][] = [];
  constructor(weekLength = 7) {
    for (let index = 0; index < weekLength; ++index) {
      this.days.push([]);
    }
  }

  getLine(dayStart: number, length: number): number {
    let index = dayStart;
    let i = 0;
    let line = 0;
    for (index; index < this.days.length && i < length; ++index) {
      const temp = this.getDayLine(index, line);
      if (temp > line) {
        index = dayStart;
        line = temp;
        i = 0;
      } else {
        ++i;
      }
    }
    this.updateLine(line, dayStart, length);
    return line;
  }

  private getDayLine(index: number, line: number) {
    for (let i = line; i < 100; ++i) {
      if (!this.days[index][line]) {
        return line;
      } else {
        ++line;
      }
    }
    return undefined;
  }

  private updateLine(line: number, dayStart: number, length: number) {
    for (let i = 0; i < length; ++i) {
      this.days[i + dayStart][line] = true;
    }
  }
}
